import type { ModelLead } from '@app/api/Leads/types';
import { NO_NAME_LABEL } from '@app/constants';

import { formatLeadRegistryTime } from '../../utils';

import type { LeadsRegistryLeadInfoViewModel } from '../types';

// Known message direction values returned by the Leads API.
// Unknown values fall back to neither incoming nor outgoing.
const DIRECTION_INCOMING = 'in';
const DIRECTION_OUTGOING = 'out';

const EMPTY_MESSAGE_LABEL = 'Нет сообщений';
const NO_COMMUNICATION_LABEL = 'Коммуникаций ещё не было';

// Без права «Просмотр контактных данных клиентов» аккаунт и телефон клиента
// не показываются и не заменяют пустое имя (issue/11538).
const getClientName = (lead: ModelLead, canShowContacts: boolean): string =>
  canShowContacts
    ? lead.ClientName ??
      lead.ClientAccountName ??
      lead.ClientPhone ??
      NO_NAME_LABEL
    : lead.ClientName || NO_NAME_LABEL;

const getClientPhone = (
  lead: ModelLead,
  canShowContacts: boolean
): string | null => {
  if (!canShowContacts || !lead.ClientPhone) return null;

  return lead.ClientPhone.startsWith('+')
    ? lead.ClientPhone
    : `+${lead.ClientPhone}`;
};

const getLastMessage = (lead: ModelLead): string => {
  if (lead.LastMessage) return lead.LastMessage;
  if (lead.IsNoCommunication) return NO_COMMUNICATION_LABEL;

  return EMPTY_MESSAGE_LABEL;
};

export const getLeadsRegistryLeadInfo = (
  lead: ModelLead,
  canShowContacts: boolean
): LeadsRegistryLeadInfoViewModel => ({
  leadId: lead.Id,
  clientId: lead.ClientId,
  avatarUrl: lead.ClientPhoto,
  clientName: getClientName(lead, canShowContacts),
  clientPhone: getClientPhone(lead, canShowContacts),
  canShowContacts,
  socialIntegrationType: lead.SocialIntegrationType,
  socialIntegrationName: lead.SоcialIntegrationName,
  lastMessage: getLastMessage(lead),
  // Пустая строка от бэкенда равнозначна отсутствию задачи
  crmTaskMessage: lead.CrmTaskMessage || null,
  lastMessageTime: formatLeadRegistryTime(lead.LastUpdate ?? lead.CreateTime),
  direction: lead.Direction,
  hasUnreadMessage: Boolean(lead.UnreadMessage),
  isIncoming: lead.Direction === DIRECTION_INCOMING,
  isOutgoing: lead.Direction === DIRECTION_OUTGOING,
  isNoAnswer: lead.IsNoAnswer,
  isNoCommunication: lead.IsNoCommunication,
});
